/** @jsxImportSource solid-js */
import { classed } from "#palette/style/index.solid";

export const Card = classed.div`rounded-lg p-5 flex flex-col gap-2 h-full bg-white border border-brand-500 shadow content-start relative`;
